import React from 'react';
import { ClipboardText } from '@phosphor-icons/react';
import MarkdownDocPage from '../components/MarkdownDocPage';

export const TestPlanPage = () => (
  <MarkdownDocPage
    apiPath="/docs/test-plan"
    title="Manual Test Plan"
    subtitle="Tick through each scenario to confirm functionality. Designed for non-technical testers."
    icon={<ClipboardText size={32} weight="duotone" className="text-gold" />}
    downloadFilename="Raiseys-User-Testing.md"
    printTitle="Raisey's Smart Saver — Manual Test Plan"
    testIdPrefix="test-plan"
    printableId="test-plan-printable"
  />
);

export default TestPlanPage;
